module.exports = __webpack_public_path__ + "static/media/post3.ca35cd79.jpg";